import { render, staticRenderFns } from "./liquidacion_comision.vue?vue&type=template&id=0f711942&"
import script from "./liquidacion_comision.vue?vue&type=script&lang=js&"
export * from "./liquidacion_comision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports